import inst from './Recursos/ic_insta.svg'
import face from './Recursos/ic_face.svg'
import tiktok from './Recursos/ic_tiktok.svg'
import ic_locacion from "./Recursos/ic_locacion.svg";
import ic_telefonos from "./Recursos/ic_telefonos.svg";
import ic_mail from "./Recursos/ic_mail.svg";


export const SECCIONES = ['Productos', 'Licencias', 'Testimonios']


export const REDES = [
    {
        nombre: 'tiktok',
        imgColor: tiktok,
        img: tiktok,
        url: 'https://www.tiktok.com/'
    },
    {
        nombre: 'facebook',
        imgColor: face,
        img: face,
        url: 'https://www.facebook.com/4'
    },
    {
        nombre: 'instagram',
        imgColor: inst,
        img: inst,
        url: 'https://www.instagram.com/origenescoffeecol/?hl=es'
    },
]

export const SELLOS = []

export const TEXTO = encodeURI('Hola Origenes Coffee')
export const LINKWASS = `https://api.whatsapp.com/send?phone=57${3164465623}&text=${TEXTO}`

export const CONTACTOS = [
    {
        nombre: 'Direccion',
        accion: 'Dirigeme',
        img: ic_locacion,
        descripcion: 'Av. Panamericana Cra 1a #12-56\n' +
            'Ipiales , Nariño',
        alto: 110,
        link: 'https://www.google.com/maps/dir/?api=1&destination=0.8301742351016915,-77.63574857946524,190&dir_action=navigate'
    },
    {
        nombre: 'Telefonos',
        descripcion: '+57 3148134166',
        img: ic_telefonos,
        accion: 'WhatsApp',
        alto: 85,
        link: LINKWASS
    },
    {
        nombre: 'Mail',
        descripcion: 'origenescoffeesas@gmail.com\n' +
            '7diegop@gmail.com',
        img: ic_mail,
        accion: 'Enviar',
        alto: 75,
        link: 'mailto:origenescoffeesas@gmail.com'
    },
]

export const POLITICAS = [
    {
        nombre: 'Privacidad de Datos',
        descripcion:'Al interactuar con la plataforma de Orígenes Coffee, usted reconoce y acepta que el responsable del tratamiento de sus datos es Orígenes Coffee, quien recolecta y procesa información personal como nombre, dirección de correo electrónico, datos de facturación, dirección física de envío y preferencias de consumo, basándose en la necesidad contractual de procesar sus pedidos de café y en el consentimiento previo otorgado para comunicaciones de marketing; estos datos son tratados bajo estrictos estándares de seguridad técnica y organizativa para garantizar su confidencialidad, integridad y disponibilidad, siendo compartidos únicamente con terceros esenciales como procesadores de pago seguros, servicios de logística de entrega y herramientas de análisis web que cumplen con marcos legales internacionales como el RGPD de la Unión Europea y la CCPA de California, garantizando que sus datos no serán vendidos a terceros ajenos a la operación; asimismo, se le informa que sus datos pueden ser transferidos internacionalmente a servidores en la nube con niveles de protección adecuados y que usted conserva en todo momento el derecho de acceder, rectificar, limitar o solicitar la supresión de su información, así como a retirar su consentimiento mediante un aviso al correo electrónico de contacto designado, entendiéndose que conservaremos su información solo durante el tiempo necesario para cumplir con las finalidades comerciales y las obligaciones legales de retención tributaria, tras lo cual serán eliminados o anonimizados de forma definitiva.',
    },
    {
        nombre: 'Tratamiento de Datos',
        descripcion:'En cumplimiento con los estándares internacionales de protección de datos personales, Orígenes Coffee informa que la información recolectada será tratada con la finalidad primordial de gestionar una comunicación directa y personalizada con el cliente para el seguimiento de sus pedidos y consultas, además de ser utilizada de forma agregada o individual para la generación de informes de impacto social, económico y ambiental en las zonas caficultoras y comunidades alrededor del mundo donde la marca tiene presencia, permitiendo medir y reportar la trazabilidad y el valor compartido de nuestra operación global; asimismo, el titular autoriza expresamente el uso de sus datos para el envío de información publicitaria, promociones exclusivas y lanzamientos de nuevos productos y servicios relacionados con la marca, ya sea mediante correo electrónico, mensajería instantánea o redes sociales, bajo el compromiso de que Orígenes Coffee implementará las medidas de seguridad necesarias para evitar el acceso no autorizado y garantizando que el usuario podrá, en cualquier momento, ejercer sus derechos de conocimiento, actualización, rectificación y supresión de sus datos, así como revocar la autorización para fines promocionales sin que esto afecte la prestación de los servicios básicos, entendiendo que los datos permanecerán en nuestras bases de datos bajo principios de minimización y necesidad mientras se mantenga la relación comercial o exista una obligación legal de conservación.',
    }
]
